import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@boma/app-config';
import { IPaginatedResponse } from '@boma/client-shared';
import { IReportStockItem } from '@boma/supplier-portal/shared/entities';
import { HelperFunctionsService } from '../helper-functions/helper-functions.service';

@Injectable({
  providedIn: 'root',
})
export class StockService {
  private base: string;
  private version: string;

  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient,
    private helperService: HelperFunctionsService
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  getAllStocksAndEnabledProducts(
    entityId: string, //required
    locationIds: string[] = [],
    definitionsFilters: { targets: number; definitionIds: string[] },
    productIds: string[] = [],
    page: string = '1',
    perPage: string = '500',
    categoryIds: string[] = [],
    brandIds: string[] = [],
    endDate: string = '', // will be implemented soon
    departmentIds: string[] = []
  ) {
    const params = {
      entityId: entityId,
      definitionsFilters,
      productFilters: {
        brandIds: brandIds,
        categoryIds: categoryIds,
        departmentIds: departmentIds,
      },
      productIds: productIds,
      locationIds: locationIds,
      endDate: endDate,
      perPage: Number(perPage),
      page: Number(page),
      locationType: null,
    };

    return this.httpClient.post<IPaginatedResponse<IReportStockItem>>(
      `${this.base}api/v${this.version}/${entityId}/Stock/Summary`,
      this.helperService.sanitizeParams(params)
    );
  }
}
